import { Pipe, PipeTransform } from '@angular/core';
declare var moment: any;

@Pipe({
  name: 'fromNow'
})
export class FromNowPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!value) return;

    return moment(value).fromNow();
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/from-now.pipe.ts